import React from 'react'
import PropTypes from 'prop-types'

import Moment from 'moment'

export default function UI5CalendarHeader(props) {
    const showLeft  = true //!props.minNavigationDate || props.minNavigationDate.isBefore(props.calendar.currentMonth, 'month')
    const showRight = true //!props.maxNavigationDate || props.maxNavigationDate.isAfter(props.calendar.currentMonth, 'month')

    const leftArrowClasses = Classes("arrow", {
        'ui5-control-button s-28 i5-angle-left': showLeft
    })

    const todayClasses = Classes("btn-today ui5-control-button i5-date-star s-28 fs-14", {
        'show'          : !props.calendar.currentMonth.isSame(Moment(), 'month'),
        'is-relative'   : props.navigationArrowsPosition === 'right'
    })

    const rightArrowClasses = Classes("arrow", {
        'ui5-control-button s-28 i5-angle-right': showRight
    })

    const onDecreaseMonth   = () => {showLeft && props.calendar.decreaseMonth()}
    const onClickMonth      = () => {props.onClickMonth(props.calendar.currentMonth)}
    const onClickToday      = () => {props.calendar.goToToday()}
    const onIncreaseMonth   = () => {showRight && props.calendar.increaseMonth()}

    switch (props.navigationArrowsPosition) {
        case 'right'        :
            return (
                <div className="navigation-header fl-sb">

                    <div className="title ui5-title-small is-button txt-truncate" onClick={onClickMonth}>{props.calendar.currentMonth.format(props.headerDateFormat)}</div>

                    <div className="flex-row-center-center">
                        {props.showTodayButton && <div className={todayClasses} onClick={onClickToday}/>}
                        <div className={Classes(leftArrowClasses, 'm-r-4')} onClick={onDecreaseMonth}/>
                        <div className={rightArrowClasses} onClick={onIncreaseMonth}/>
                    </div>
                </div>
            )

        case 'left-right'   :
        default             :
            return (
                <div className="navigation-header fl-sb">
                    <div className={leftArrowClasses} onClick={onDecreaseMonth}/>
                    <div className="title ui5-title-small is-button" onClick={onClickMonth}>{props.calendar.currentMonth.format(props.headerDateFormat)}</div>
                    {props.showTodayButton && <div className={todayClasses} onClick={onClickToday}></div>}
                    <div className={rightArrowClasses} onClick={onIncreaseMonth}/>
                </div>
            )
    }
}

UI5CalendarHeader.propTypes = {
    calendar                : PropTypes.object,
    navigationArrowsPosition: PropTypes.oneOf(['left-right', 'right']),     // header navigation arrow left on left and right on right side or both on right side
    headerDateFormat        : PropTypes.string,

    minNavigationDate       : PropTypes.object,
    maxNavigationDate       : PropTypes.object,

    showTodayButton         : PropTypes.bool,

    onClickToday            : PropTypes.func,
    onClickMonth            : PropTypes.func,
}

UI5CalendarHeader.defaultProps = {
    navigationArrowsPosition: 'left-right',
    headerDateFormat        : "MMMM YYYY"
}